// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-3bqep","btnDetail":"index-btnDetail-1gHJg","active":"index-active-1jR8h"};